module.exports = __webpack_public_path__ + "img/drone.d93455b0.jpg";